export const ERROR_HEADER = `Something's gone wrong`
export const ERROR_SUBHEADER = `An error occurred while we  
  were saving your class.`
export const errorSubheaderStatus = status => {
  if (status === 'HideSmallGroup') {
    return 'An error occurred while trying to hide your small group.'
  }
  return `An error occurred while trying to ${status.toLowerCase()} your class.`
}
export const ERROR_RETRY = `Try Again`
